import { render, staticRenderFns } from "./commit.vue.js?vue&type=template&id=5918fb4c&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./commit.vue?vue&type=template&id=5918fb4c&vue3"
import script from "./commit.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./commit.vue?vue&type=script&lang=js&vue3"
export * from "./commit.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./commit.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports